import streamers from '../images/streamers.jpg'

css .youth-page
	min-height:100vh
	d:flex
	fld:column
	.shape-header
		h:300px
				
tag youth-page
	<self.youth-page>
		<shape-header title="Youth" image=streamers>
		<text-block.who-we-are title="Youth">
			"Coming soon..."

		<footer-section>